// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"624e5edf","453":"d68e0bc6","455":"fc98f75f"}[chunkId] + ".chunk.js";
};